import * as React from "react";
import {
  TextField,
  Button,
  Stack,
  InputAdornment,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  Checkbox,
  Tooltip as MUITooltip,
  FormControlLabel,
  Box,
  Input,
} from "@mui/material";
import { Check, Save } from "@mui/icons-material";
import ModalUI from "../UI/ModalUI";
import { useDispatch, useSelector } from "react-redux";
import InputTextField from "../UI/InputTextField";
import SelectFilter from "../UI/SelectFilter";
import { setLoading } from "../../store/loading";
import {
  getAllFormTemplate,
  getAllFormTemplateSearch,
} from "../../store/formTemplate";
import { getFormInputesById } from "../../store/formInputes";
import { getCustomTextLength } from "../helper/CustomLabel";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { OSHMA_TYPE } from "../../data/dummy-data";
import RangeListManager from "./RangeListManager";
import useFormsFormulaStore from "../../store/zustandStore/formsFormulaZs";
import PlayCircleFilledIcon from "@mui/icons-material/PlayCircleFilled";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const DataQueryModalEditor = (props) => {
  const dispatch = useDispatch();
  const { formTemplate, searchValueCurrent } = useSelector(
    (state) => state.formTemplate,
  );

  const { formInputesById } = useSelector((state) => state.formInputesById);

  const {
    getEvaluateFormFormulaZs,
    evaluateFormFormulaZs,
    updateFormFormulaZs,
    createFormFormulaZs,
    getDataForTableChartZs,
  } = useFormsFormulaStore();

  const { data, isstatusnew, open } = props;
  const [yearTest, setYearTest] = React.useState(2024);
  const [state, setState] = React.useState({
    name: "",
    apiCall: "",
    postProcessing: "",
    groupByOshmaType: true,
    payload: {
      apiFormFormula: {
        apiEndpoint: "",
      },
      simpleFormFormula: {
        formInputIds: [],
        groupByFormInputId: null,
      },
      aggregationFormFormula: {
        formInputFunction: {
          birthday: {}, // per te llogaritur moshen
          timeDiffInMonthsFunction: {
            otherFormInputId: null, //data e fillimit te punes indikatori
          },
        },
        formInputId: null,
        grouping: {
          groupingFunctionType: "COUNT",
          labels: {},
          ranges: [
            // {
            //   label: "",
            //   max: 0,
            //   min: 0,
            // },
          ],
        },
      },
    },
    formId: "",
    form: null,
    functionInput: "",
    oshmaCategories: [],
    inputGroup: "",
    rangeFilter: "",
    functionInputObject: null,
  });
  const [formInputFunctionBirthday, setFormInputFunctionBirthday] =
    React.useState(false);
  const [formInputFunctionMonth, setFormInputFunctionMonth] =
    React.useState(false);
  const [formInputMonth, setFormInputMonth] = React.useState("");

  const [stateContentApiTest, setStateContentApiTest] = React.useState("");
  const [openContentApiTest, setOpenContentApiTest] = React.useState(false);
  const [aggregationFormFormulaGrouping, setAggregationFormFormulaGrouping] =
    React.useState("list");
  const [errorValues, setErrorValues] = React.useState([]);
  const [stateTypeFilter, setStateTypeFilter] = React.useState("");
  const [stateAggregationList, setStateAggregationList] = React.useState(false);
  const [stateListAggregationIndicator, setStateListAggregationIndicator] =
    React.useState([]);
  const [
    stateListAggregationIndicatorPercentage,
    setStateListAggregationIndicatorPercentage,
  ] = React.useState([]);
  const [
    stateListAggregationCountIndicator,
    setStateListAggregationCountIndicator,
  ] = React.useState([]);
  const searchStateForm = React.useRef("");
  const [searchValueServerForm, setSearchValueServerForm] = React.useState("");
  const [anchorElForm, setAnchorElForm] = React.useState(null);
  const [anchorElFunctionInput, setAnchorElFunctionInput] =
    React.useState(null);
  const [anchorElFormInputMonth, setAnchorElFormInputMonth] =
    React.useState(null);

  const [anchorElIndicatorList, setAnchorElIndicatorList] =
    React.useState(null);

  const [anchorElOshmaCategories, setAnchorElOshmaCategories] =
    React.useState(null);

  const openForm = Boolean(anchorElForm);
  const openFunctionInput = Boolean(anchorElFunctionInput);
  const openFormInputMonth = Boolean(anchorElFormInputMonth);
  const openFunctionOshmaCategories = Boolean(anchorElOshmaCategories);

  React.useEffect(() => {
    // setErrorValues([]);
    // getAllDataFormFirst();
    if (data) {
      const fetchData = async () => {
        setErrorValues([]);

        try {
          await dispatch(
            getAllFormTemplate({
              page: 0,
              searchValue: searchValueServerForm,
              limit: 100,
            }),
          ).unwrap(); // wait for data to finish loading

          if (
            data?.payload?.aggregationFormFormula ||
            data?.payload?.multiAggregationFormFormula
          ) {
            setStateTypeFilter("AGGREGATION");
            await getAllDataFormIndikator();
            if (data?.payload?.multiAggregationFormFormula) {
              setStateAggregationList(true);
            } else {
              setStateAggregationList(false);
            }
          }
          if (data?.payload?.simpleFormFormula) {
            setStateTypeFilter("SIMPLE");
            getAllDataFormIndikator();
          }

          if (data?.payload?.apiFormFormula?.apiEndpoint) {
            setStateTypeFilter("API");
          }

          if (data?.payload?.multiAggregationFormFormula) {
            const multiformulaTemp = {
              apiFormFormula: null,
              aggregationFormFormula:
                data?.payload?.multiAggregationFormFormula[0],
              multiAggregationFormFormula: null,
              simpleFormFormula: null,
            };
            await getAllDataFormIndikator();

            setState({
              apiCall: data?.apiCall ? data?.apiCall : "",
              form: data?.form ? data?.form : null,
              functionInput: data?.functionInput ? data?.functionInput : "",
              functionInputObject: data?.form ? data?.form : null,
              oshmaCategories: data?.oshmaCategories
                ? data?.oshmaCategories
                : [],
              inputGroup: data?.inputGroup ? data?.inputGroup : "",
              rangeFilter: data?.rangeFilter ? data?.rangeFilter : "",

              id: data.id ? data.id : "",
              name: data.name ? data.name : "",
              formId: data.formId ?? "",
              groupByOshmaType: data?.groupByOshmaType
                ? data?.groupByOshmaType
                : false,
              payload: multiformulaTemp ? multiformulaTemp : {},
              type: stateTypeFilter,
              postProcessing: data.postProcessing ? data.postProcessing : "",
              multiAggregationFormFormula: data?.payload
                ?.multiAggregationFormFormula
                ? data?.payload?.multiAggregationFormFormula
                : null,
            });

            if (
              multiformulaTemp?.aggregationFormFormula?.grouping?.ranges !==
              null
            ) {
              setAggregationFormFormulaGrouping("number");
            } else {
              setAggregationFormFormulaGrouping("list");
            }
          } else {
            setState({
              apiCall: data?.apiCall ? data?.apiCall : "",
              form: data?.form ? data?.form : null,
              functionInput: data?.functionInput ? data?.functionInput : "",
              functionInputObject: data?.form ? data?.form : null,
              oshmaCategories: data?.oshmaCategories
                ? data?.oshmaCategories
                : [],
              inputGroup: data?.inputGroup ? data?.inputGroup : "",
              rangeFilter: data?.rangeFilter ? data?.rangeFilter : "",

              id: data.id ? data.id : "",
              name: data.name ? data.name : "",
              formId: data.formId ?? "",
              groupByOshmaType: data?.groupByOshmaType
                ? data?.groupByOshmaType
                : false,
              payload: data?.payload ? data?.payload : {},
              type: stateTypeFilter,
              postProcessing: data.postProcessing ? data.postProcessing : "",
            });

            if (
              data?.payload?.aggregationFormFormula?.grouping?.ranges !== null
            ) {
              setAggregationFormFormulaGrouping("number");
            } else {
              setAggregationFormFormulaGrouping("list");
            }

            if (
              data?.payload?.aggregationFormFormula?.formInputFunction?.birthday
            ) {
              setFormInputFunctionBirthday(true);
            } else {
              setFormInputFunctionBirthday(false);
            }

            if (
              data?.payload?.aggregationFormFormula?.formInputFunction
                ?.timeDiffInMonthsFunction &&
              data?.payload?.aggregationFormFormula?.formInputFunction
                ?.timeDiffInMonthsFunction?.otherFormInputId !== ""
            ) {
              setFormInputFunctionMonth(true);
              setFormInputMonth(
                data?.payload?.aggregationFormFormula?.formInputFunction
                  ?.timeDiffInMonthsFunction?.otherFormInputId,
              );
            } else {
              setFormInputFunctionMonth(false);
            }
          }
          setAnchorElForm(null);
        } catch (err) {
          console.error("Failed to load form data:", err);
        }
      };
      fetchData();
    }
  }, [data, open]);

  React.useEffect(() => {
    if (state?.multiAggregationFormFormula && formInputesById?.length !== 0) {
      const listIndicatiorsSUM = state?.multiAggregationFormFormula.map(
        (item) => {
          if (item.grouping?.groupingFunctionType === "SUM") {
            const found = formInputesById.find(
              (labelItem) => labelItem.id === item.grouping?.otherFormInputId,
            );
            return {
              id: item.grouping?.otherFormInputId,
              name: item.grouping?.otherFormInputId,
              idLabel: item.grouping?.otherFormInputId,
              label: found ? found?.label : null, // ose vendos '' në vend të null
            };
          }
        },
      );
      const listIndicatiorsCOUNT = state?.multiAggregationFormFormula.map(
        (item) => {
          if (
            item?.grouping?.groupingFunctionType === "COUNT" &&
            item?.formInputFunction === null
          ) {
            const found = formInputesById.find(
              (labelItem) => labelItem.id === item?.formInputId,
            );
            return {
              id: item?.formInputId,
              name: item?.formInputId,
              idLabel: item?.formInputId,
              label: found ? found.label : null, // ose vendos '' në vend të null
            };
          }
        },
      );

      const listIndicatiorsPERCEN = state?.multiAggregationFormFormula.map(
        (item) => {
          if (
            item?.grouping?.groupingFunctionType === "COUNT" &&
            item?.formInputFunction?.percentageFunction
          ) {
            const found = formInputesById.find(
              (labelItem) =>
                labelItem.id ===
                item?.formInputFunction?.percentageFunction?.otherFormInputId,
            );
            return {
              id: item?.formInputFunction?.percentageFunction?.otherFormInputId,
              name: item?.formInputFunction?.percentageFunction
                ?.otherFormInputId,
              idLabel:
                item?.formInputFunction?.percentageFunction?.otherFormInputId,
              label: found ? found.label : null, // ose vendos '' në vend të null
            };
          }
        },
      );

      setStateListAggregationCountIndicator(
        listIndicatiorsCOUNT?.filter(
          (item) => item !== null && item !== undefined,
        ),
      );
      setStateListAggregationIndicator(
        listIndicatiorsSUM?.filter(
          (item) => item !== null && item !== undefined,
        ),
      );
      setStateListAggregationIndicatorPercentage(
        listIndicatiorsPERCEN?.filter(
          (item) => item !== null && item !== undefined,
        ),
      );
      setState({
        ...state,
        multiAggregationFormFormula: null,
      });
    }
  }, [state?.multiAggregationFormFormula, formInputesById]);

  const handleInputChange = (event) => {
    const { name, value } = event?.target;

    if (name === "API") {
      setState({
        ...state,
        payload: { apiFormFormula: { apiEndpoint: value ? value : "" } },
      });
    } else {
      setState({ ...state, [name]: value ? value : "" });
    }
  };

  const generateDataQuery = async () => {
    if (stateTypeFilter === "API") {
      const responseApiTest = await getDataForTableChartZs(
        "API",
        state?.payload?.apiFormFormula?.apiEndpoint,
        state?.postProcessing,
      );

      if (
        state?.postProcessing &&
        state?.postProcessing !== "string" &&
        state?.postProcessing !== null &&
        state?.postProcessing !== undefined &&
        state?.postProcessing !== ""
      ) {
        let groupByType;
        try {
          groupByType = eval(`(${state?.postProcessing})`);
          setStateContentApiTest(
            JSON.stringify(groupByType(responseApiTest.data, null, 2) ?? {}),
          );
          setOpenContentApiTest(true);
        } catch (err) {
          console.error("Eval failed:", err);
          setStateContentApiTest("Eval failed:", err);
          setOpenContentApiTest(true);
          return; // stop execution
        }
      } else {
        setStateContentApiTest(JSON.stringify(responseApiTest, null, 2));
        setOpenContentApiTest(true);
      }
    } else {
      const responseApiTest = await getEvaluateFormFormulaZs({
        formulaId: data.id,
        year: yearTest,
      });
      setStateContentApiTest(JSON.stringify(responseApiTest, null, 2));
      setOpenContentApiTest(true);
    }
  };

  const searchItemsForm = (e) => {
    const searchValue = e.target.value;
    if (searchValue !== "") {
      searchStateForm.current.value = searchValue;
      let filterTimeout;
      filterTimeout = setTimeout(() => {
        setSearchValueServerForm(searchStateForm.current?.value);
      }, 1000);
    } else {
      setSearchValueServerForm("");
    }
  };

  React.useEffect(() => {
    if (isstatusnew) {
      getAllDataFormFirst();
      setStateAggregationList(false);
      setStateListAggregationIndicator([]);
      setStateListAggregationCountIndicator([]);
      setStateTypeFilter("");
    }
  }, [open]);

  React.useEffect(() => {
    if (!isstatusnew) {
      getAllDataFormIndikator();
    }
  }, [state?.formId, dispatch]);

  const saveDataQuery = () => {
    let grouping = {
      groupingFunctionType:
        state?.payload?.aggregationFormFormula?.grouping?.groupingFunctionType,
    };

    if (aggregationFormFormulaGrouping === "list") {
      grouping.labels =
        state?.payload?.aggregationFormFormula?.grouping?.labels;
    } else if (state?.payload?.aggregationFormFormula?.grouping?.ranges) {
      grouping.ranges =
        state?.payload?.aggregationFormFormula?.grouping?.ranges;
    }

    if (stateTypeFilter === "AGGREGATION" && !stateAggregationList) {
      let formInputFunction;
      if (formInputFunctionBirthday) {
        formInputFunction = {
          birthday: {}, // per te llogaritur moshen
          timeDiffInMonthsFunction: {
            otherFormInputId: null, // data e fillimit te punes indikatori
          },
        };
      } else {
        if (formInputFunctionMonth && formInputMonth !== "") {
          formInputFunction = {
            timeDiffInMonthsFunction: {
              otherFormInputId: formInputMonth,
            },
          };
        } else {
          formInputFunction = null;
        }
      }

      const payloadAggregationTemp = {
        aggregationFormFormula: {
          formInputId: state?.payload?.aggregationFormFormula?.formInputId,
          formInputFunction,
          grouping,
        },
      };

      const tempAggeragationSentAdd = {
        name: state.name,
        formId: state.formId,
        groupByOshmaType: state?.groupByOshmaType,
        payload: payloadAggregationTemp,
        type: stateTypeFilter,
        postProcessing: state.postProcessing,
      };
      if (isstatusnew) {
        createFormFormulaZs(tempAggeragationSentAdd);
      } else {
        updateFormFormulaZs({ id: state.id, ...tempAggeragationSentAdd });
      }
    } else {
      let formInputFunction;
      if (formInputFunctionBirthday) {
        formInputFunction = {
          birthday: {}, // per te llogaritur moshen
          timeDiffInMonthsFunction: {
            otherFormInputId: null, // data e fillimit te punes indikatori
          },
        };
      } else {
        if (formInputFunctionMonth && formInputMonth !== "") {
          formInputFunction = {
            timeDiffInMonthsFunction: {
              otherFormInputId: formInputMonth,
            },
          };
        } else {
          formInputFunction = null;
        }
      }

      const listOfAggregationInputsSUM = stateListAggregationIndicator.map(
        (item) => {
          let grouping2 = {
            otherFormInputId: item?.id,
            groupingFunctionType: "SUM",
          };

          if (aggregationFormFormulaGrouping === "list") {
            grouping2.labels =
              state?.payload?.aggregationFormFormula?.grouping?.labels;
          } else if (state?.payload?.aggregationFormFormula?.grouping?.ranges) {
            grouping2.ranges =
              state?.payload?.aggregationFormFormula?.grouping?.ranges;
          }

          return {
            formInputId: state?.payload?.aggregationFormFormula?.formInputId,
            formInputFunction,
            grouping: grouping2,
          };
        },
      );

      const listOfAggregationInputsCOUNT =
        stateListAggregationCountIndicator.map((item) => {
          let grouping2 = {
            otherFormInputId: null,
            groupingFunctionType: "COUNT",
          };

          if (aggregationFormFormulaGrouping === "list") {
            grouping2.labels =
              state?.payload?.aggregationFormFormula?.grouping?.labels;
          } else if (state?.payload?.aggregationFormFormula?.grouping?.ranges) {
            grouping2.ranges =
              state?.payload?.aggregationFormFormula?.grouping?.ranges;
          }

          return {
            formInputId: item?.id,
            formInputFunction,
            grouping: grouping2,
          };
        });

      const listOfAggregationInputsPERCENTAGE =
        stateListAggregationIndicatorPercentage.map((item) => {
          let grouping2 = {
            otherFormInputId: null,
            groupingFunctionType: "COUNT",
          };

          if (aggregationFormFormulaGrouping === "list") {
            grouping2.labels =
              state?.payload?.aggregationFormFormula?.grouping?.labels;
          } else if (state?.payload?.aggregationFormFormula?.grouping?.ranges) {
            grouping2.ranges =
              state?.payload?.aggregationFormFormula?.grouping?.ranges;
          }
          let formInputFunctionTemp = {
            percentageFunction: {
              otherFormInputId: item?.id,
            },
          };

          return {
            formInputId: state?.payload?.aggregationFormFormula?.formInputId,
            formInputFunction: formInputFunctionTemp,
            grouping: grouping2,
          };
        }); // TEST

      const listOfAggregationInputs = [
        ...listOfAggregationInputsCOUNT,
        ...listOfAggregationInputsSUM,
        ...listOfAggregationInputsPERCENTAGE,
      ];

      const payloadAggregationTemp = {
        multiAggregationFormFormula: listOfAggregationInputs,
      };

      const tempAggeragationSentAdd = {
        name: state.name,
        formId: state.formId,
        groupByOshmaType: state?.groupByOshmaType,
        payload: payloadAggregationTemp,
        type: stateTypeFilter,
        postProcessing: state.postProcessing,
      };
      if (isstatusnew) {
        createFormFormulaZs(tempAggeragationSentAdd);
      } else {
        updateFormFormulaZs({ id: state.id, ...tempAggeragationSentAdd });
      }
    } // multiaggregation

    if (stateTypeFilter === "SIMPLE") {
      const payloadSimpleTemp = {
        simpleFormFormula: state?.payload?.simpleFormFormula,
      };

      const tempSimpleSentAdd = {
        name: state.name,
        formId: state.formId,
        groupByOshmaType: state.groupByOshmaType,
        payload: payloadSimpleTemp,
        type: stateTypeFilter,
        postProcessing: state.postProcessing,
      };

      if (isstatusnew) {
        createFormFormulaZs(tempSimpleSentAdd);
      } else {
        updateFormFormulaZs({ id: state.id, ...tempSimpleSentAdd });
      }
    }

    if (stateTypeFilter === "API") {
      const payloadApiTemp = {
        apiFormFormula: state?.payload?.apiFormFormula,
      };
      const tempApiSentAdd = {
        name: state.name,
        formId: null,
        groupByOshmaType: false,
        payload: payloadApiTemp,
        type: stateTypeFilter,
        postProcessing: state.postProcessing,
        filterByOshmaTypes: null,
      };
      if (isstatusnew) {
        createFormFormulaZs(tempApiSentAdd);
      } else {
        updateFormFormulaZs({ id: state.id, ...tempApiSentAdd });
      }
    }
    props.onClose();
  };

  const checkError = (item) => {
    if (errorValues.find((element) => element === item)) {
      return true;
    } else {
      return false;
    }
  };

  const changeTypeFilter = (event) => {
    const { value } = event.target;
    setStateTypeFilter(value);
    setState({ ...state, type: value ? value : "" });
  };

  // Form handle

  const handleClickForm = (event) => {
    setAnchorElForm(event.currentTarget);
  };

  const handleClickFormInputMonth = (event) => {
    setAnchorElFormInputMonth(event.currentTarget);
    // getAllDataFormIndikator();
  };

  const handleClickOshmaCategories = (event) => {
    setState({
      ...state,
    });
    setAnchorElOshmaCategories(event.currentTarget);
  };

  const handleClickIndicatorList = (event) => {
    setAnchorElIndicatorList(event.currentTarget);
    getAllDataFormIndikator();
  };

  const handleCloseOshmaCategories = () => {
    setAnchorElOshmaCategories(null);
  };

  const handleCloseForm = () => {
    setAnchorElForm(null);
  };

  const handleCloseFunctionInput = () => {
    setAnchorElFunctionInput(null);
  };

  const handleCloseFormInputMonth = () => {
    setAnchorElFormInputMonth(null);
  };

  const getAllDataFormFirst = async () => {
    dispatch(setLoading(true));
    dispatch(
      getAllFormTemplate({
        page: 0,
        searchValue: searchValueServerForm,
        limit: 100,
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(setLoading(false));
      })
      .catch(() => {
        dispatch(setLoading(false));
      });
  };

  const handleClickFunctionInput = (event) => {
    getAllDataFormIndikator();
    setState({
      ...state,
    });
    setAnchorElFunctionInput(event.currentTarget);
  };

  const getAllDataFormIndikator = async () => {
    dispatch(setLoading(true));
    await dispatch(getFormInputesById({ id: state.formId }))
      .unwrap()
      .then(() => {
        dispatch(setLoading(false));
      })
      .catch(() => {
        dispatch(setLoading(false));
      });
  };

  const handleLabelChange = (item) => {
    if (aggregationFormFormulaGrouping === "list") {
      setState((prev) => ({
        ...prev,
        payload: {
          ...prev.payload,
          aggregationFormFormula: {
            ...prev.payload?.aggregationFormFormula,
            grouping: {
              ...prev.payload?.aggregationFormFormula?.grouping,
              labels: item, // your updated labels object
            },
          },
        },
      }));
    } else {
      setState((prev) => ({
        ...prev,
        payload: {
          ...prev.payload,
          aggregationFormFormula: {
            ...prev.payload?.aggregationFormFormula,
            grouping: {
              ...prev.payload?.aggregationFormFormula?.grouping,
              ranges: item, // your updated labels object
            },
          },
        },
      }));
    }
  };

  const handleGroupingFunctionType = (e) => {
    setState((prev) => ({
      ...prev,
      payload: {
        ...prev.payload,
        aggregationFormFormula: {
          ...prev.payload?.aggregationFormFormula,
          grouping: {
            ...prev.payload?.aggregationFormFormula?.grouping,
            groupingFunctionType: e.target.value, // your updated groupingFunctionType COUNT | SUM
          },
        },
      },
    }));
  };

  const handleAggregationFormFormulaGrouping = (e) => {
    setAggregationFormFormulaGrouping(e.target.value);

    // setState((prev) => ({
    //   ...prev,
    //   payload: {
    //     ...prev.payload,
    //     aggregationFormFormula: {
    //       ...prev.payload?.aggregationFormFormula,
    //       grouping: {
    //         ...prev.payload?.aggregationFormFormula?.labels,
    //         groupingFunctionType: value, // your updated groupingFunctionType COUNT | SUM
    //       },
    //     },
    //   },
    // }));
  };

  function filterItemsByIdList(items, idList) {
    return items
      .filter((item) => idList.includes(item.id))
      .map(({ id, label }) => ({ id, label }));
  }

  return (
    <ModalUI {...props}>
      <Stack spacing={2}>
        <TextField
          name="name"
          required
          autoComplete="off"
          id="name"
          variant="outlined"
          error={checkError("name")}
          helperText={checkError("name") ? "Emri është i detyruar" : null}
          InputProps={{
            startAdornment: (
              <InputAdornment
                sx={{
                  "&.MuiInputAdornment-root": {
                    minWidth: "100px",
                  },
                }}
                position="start"
              >
                Emër
              </InputAdornment>
            ),
          }}
          value={state.name}
          onChange={handleInputChange}
        />
        <Stack direction="row" spacing={1} sx={{ margin: "0px 4px" }}>
          <Stack direction="row" alignItems="center">
            <InputLabel required sx={{ marginRight: "20px" }}>
              Tipi
            </InputLabel>
            <Select
              value={stateTypeFilter}
              onChange={changeTypeFilter}
              sx={{
                width: "130px",
                height: "40px",
                borderRadius: "5px",
                backgroundColor: "#F6F8FC",
                marginRight: "20px",
              }}
            >
              {[
                { value: "SIMPLE", label: "I thjeshte" },
                { value: "AGGREGATION", label: "Agregim" },
                { value: "API", label: "API" },
              ].map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
            {stateTypeFilter === "AGGREGATION" && (
              <FormControlLabel
                sx={{ marginRight: "40px", alignSelf: "flex-end" }}
                value="start"
                control={
                  <Checkbox
                    name="aggregationList"
                    id="aggregationList"
                    defaultChecked={false}
                    checked={stateAggregationList}
                    onChange={(e) => {
                      setStateAggregationList(
                        e.target?.checked ? e.target.checked : false,
                      );
                    }}
                  ></Checkbox>
                }
                label="Agregim List"
                labelPlacement="start"
              />
            )}
          </Stack>
        </Stack>
        {stateTypeFilter === "API" && (
          <>
            <Stack>
              <InputTextField
                label="API"
                required
                borderRadius={"16px"}
                name="API"
                id="API"
                value={state?.payload?.apiFormFormula?.apiEndpoint}
                sx={{ width: "100%" }}
                onChange={handleInputChange}
              ></InputTextField>
            </Stack>{" "}
          </>
        )}
        {(stateTypeFilter === "SIMPLE" ||
          stateTypeFilter === "AGGREGATION") && (
          <Stack>
            {stateTypeFilter !== "API" &&
              formTemplate?.find(
                (item) =>
                  item.id === state?.formId && item.role === "ROLE_OSHMA",
              ) && (
                <Stack spacing={2} sx={{ mr: "10px", width: "100%" }}>
                  <FormControlLabel
                    sx={{ marginRight: "40px", alignSelf: "flex-end" }}
                    value="start"
                    control={
                      <Checkbox
                        name="groupByOshmaType"
                        id="groupByOshmaType"
                        defaultChecked={false}
                        checked={state.groupByOshmaType}
                        onChange={(e) => {
                          setState({
                            ...state,
                            groupByOshmaType: e.target?.checked
                              ? e.target.checked
                              : false,
                          });
                        }}
                      ></Checkbox>
                    }
                    label="Grupim sipas OSHMA"
                    labelPlacement="start"
                  />
                </Stack>
              )}
            <Stack sdirection="row" spacing={1} sx={{ margin: "0px 4px 16px" }}>
              <InputLabel required>Forma</InputLabel>
              <SelectFilter
                textfield
                // disabledfilter={!state.reportingUnitId}
                zIndexPopper={2}
                name="formId"
                id="formId"
                label="Forma"
                placeholder="Kërko Formë"
                noOptionsText="Nuk ka formë"
                value={state?.formId ?? null}
                onClick={handleClickForm}
                source={formTemplate}
                maxWidth={"100%"}
                // source={[{ id: "1", value: "test" }]}
                open={openForm}
                anchorEl={anchorElForm}
                onClickAway={handleCloseForm}
                onClose={(event, reason) => {
                  if (reason === "escape") {
                    handleCloseForm();
                  }
                }}
                onChange={(event, newValue, reason) => {
                  if (
                    event.type === "keydown" &&
                    event.key === "Backspace" &&
                    reason === "removeOption"
                  ) {
                    return;
                  }

                  setState({
                    ...state,
                    formId: newValue?.id ? newValue?.id : "",
                    form: newValue ? newValue : null,
                    payload: {
                      apiFormFormula: {
                        apiEndpoint: "",
                      },
                      simpleFormFormula: {
                        formInputIds: [],
                        groupByFormInputId: "",
                      },
                      aggregationFormFormula: {
                        formInputFunction: {
                          birthday: {},
                          timeDiffInMonthsFunction: {
                            otherFormInputId: "",
                          },
                        },
                        formInputId: "",
                        grouping: {
                          groupingFunctionType: "COUNT",
                          labels: {},
                          ranges: [
                            // {
                            //   label: "",
                            //   max: 0,
                            //   min: 0,
                            // },
                          ],
                        },
                      },
                    },
                  });
                  getAllDataFormIndikator();
                  handleCloseForm();
                }}
                onchangesearch={searchItemsForm}
                inputRef={searchStateForm}
              ></SelectFilter>
            </Stack>
            {state?.form !== null && state?.form?.role === "ROLE_OSHMA" && (
              <Stack
                sdirection="row"
                spacing={1}
                sx={{ margin: "0px 4px 16px" }}
              >
                <InputLabel>Kategorite e OSHMA</InputLabel>
                <MUITooltip
                  title={
                    state?.indikatorsList ? state?.indikatorsList[0]?.label : ""
                  }
                  arrow
                >
                  <Autocomplete
                    multiple
                    disabled={!state.formId}
                    onOpen={handleClickOshmaCategories}
                    // onClick={handleClickIndikator}
                    sx={{
                      "& .MuiAutocomplete-root .MuiOutlinedInput-root": {
                        padding: "0px !important",
                      },
                    }}
                    renderTags={(values) =>
                      state?.oshmaCategories?.length !== 0
                        ? getCustomTextLength(
                            state.oshmaCategories[0]?.label,
                            20,
                          ) +
                          String(
                            state.oshmaCategories?.length > 1 ? "  +" : "",
                          ) +
                          String(
                            state.oshmaCategories?.length > 1
                              ? state.oshmaCategories?.length - 1
                              : "",
                          )
                        : ""
                    }
                    id="checkboxes-tags-demo"
                    options={OSHMA_TYPE}
                    disableCloseOnSelect
                    value={state?.oshmaCategories}
                    getOptionLabel={(option) => option.label}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.label}
                      </li>
                    )}
                    onChange={(event, newValue, reason) => {
                      if (
                        event.type === "keydown" &&
                        event.key === "Backspace" &&
                        reason === "removeOption"
                      ) {
                        return;
                      }

                      setState((state) => ({
                        ...state,
                        oshmaCategories: newValue ? newValue : [],
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        sx={{
                          minWidth: "250px",
                          maxWidth: "250px",
                          height: "50px",

                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          // height: "auto",
                          marginRight: "20px",
                          width: "min-content",

                          "& .Mui-disabled": {
                            "fieldset ": {
                              // borderColor: "#72aeff !important",
                              minWidth: "250px",
                              maxWidth: "250px",
                            },
                          },
                          "& .MuiInputBase-root.MuiOutlinedInput-root": {
                            backgroundColor: "#f6f8fc",
                            borderRadius: "12px",
                            height: "50px",
                          },
                          "& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled":
                            {
                              WebkitTextFillColor: "#091B3D !important",
                            },
                        }}
                        {...params}
                      />
                    )}
                  />
                </MUITooltip>
              </Stack>
            )}
            {stateTypeFilter === "SIMPLE" && (
              <Stack
                sdirection="row"
                spacing={1}
                sx={{ margin: "0px 4px 16px" }}
              >
                <InputLabel>Lista e Indikatorve</InputLabel>
                <MUITooltip
                  title={
                    state?.indikatorsList ? state?.indikatorsList[0]?.label : ""
                  }
                  arrow
                >
                  <Autocomplete
                    multiple
                    disabled={!state.formId}
                    onOpen={handleClickIndicatorList}
                    // onClick={handleClickIndikator}
                    width={"100%"}
                    sx={{
                      "& .MuiAutocomplete-root .MuiOutlinedInput-root": {
                        padding: "0px !important",
                      },
                    }}
                    renderTags={(values) => {
                      return values?.length !== 0
                        ? getCustomTextLength(values[0]?.label, 20) +
                            String(values.length > 1 ? "  +" : "") +
                            String(values.length > 1 ? values.length - 1 : "")
                        : "";
                    }}
                    id="checkboxes-tags-demo"
                    options={formInputesById}
                    disableCloseOnSelect
                    value={
                      state?.payload?.simpleFormFormula?.formInputIds
                        ? filterItemsByIdList(
                            formInputesById,
                            state?.payload?.simpleFormFormula?.formInputIds,
                          )
                        : []
                    }
                    getOptionLabel={(option) => option.label}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          // checked={selected}
                          checked={state?.payload?.simpleFormFormula?.formInputIds.includes(
                            option.id,
                          )}
                          onClick={() => {
                            const idList =
                              state?.payload?.simpleFormFormula?.formInputIds ??
                              [];
                            if (idList.includes(option.id)) {
                              // state?.payload?.simpleFormFormula?.formInputIds.filter(itemId => itemId !== option.id)
                              setState({
                                ...state,
                                payload: {
                                  ...state?.payload,
                                  simpleFormFormula: {
                                    ...state?.payload?.simpleFormFormula,
                                    groupByFormInputId: state?.payload
                                      ?.simpleFormFormula?.groupByFormInputId
                                      ? state?.payload?.simpleFormFormula
                                          ?.groupByFormInputId
                                      : null,
                                    formInputIds: idList.filter(
                                      (itemId) => itemId !== option.id,
                                    ),
                                  },
                                },
                              });
                            } else {
                              setState({
                                ...state,
                                payload: {
                                  ...state?.payload,
                                  simpleFormFormula: {
                                    ...state?.payload?.simpleFormFormula,
                                    groupByFormInputId: state?.payload
                                      ?.simpleFormFormula?.groupByFormInputId
                                      ? state?.payload?.simpleFormFormula
                                          ?.groupByFormInputId
                                      : null,
                                    formInputIds: idList.includes(option?.id)
                                      ? idList
                                      : [...idList, option?.id],
                                  },
                                },
                              });
                            }
                          }}
                        />
                        {option.label}
                      </li>
                    )}
                    onChange={(event, newValue, reason) => {
                      if (
                        event.type === "keydown" &&
                        event.key === "Backspace" &&
                        reason === "removeOption"
                      ) {
                        return;
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        sx={{
                          minWidth: "250px",
                          maxWidth: "100%",
                          height: "50px",

                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          // height: "auto",
                          marginRight: "20px",
                          // width: "min-content",

                          "& .Mui-disabled": {
                            "fieldset ": {
                              // borderColor: "#72aeff !important",
                              minWidth: "250px",
                              maxWidth: "100%",
                            },
                          },
                          "& .MuiInputBase-root.MuiOutlinedInput-root": {
                            backgroundColor: "#f6f8fc",
                            borderRadius: "12px",
                            height: "50px",
                          },
                          "& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled":
                            {
                              WebkitTextFillColor: "#091B3D !important",
                            },
                        }}
                        {...params}
                      />
                    )}
                  />
                </MUITooltip>
              </Stack>
            )}
            <Stack
              direction="column"
              spacing={1}
              sx={{ margin: "0px 4px 16px" }}
            >
              <InputLabel>
                {stateTypeFilter === "AGGREGATION"
                  ? "Indikatori i funksionit"
                  : "Grupo sipas Indikatorit"}
              </InputLabel>
              <SelectFilter
                textfield
                cleanIcon
                onClean={() => {
                  if (stateTypeFilter === "AGGREGATION") {
                    setState({
                      ...state,
                      // functionInputObject: newValue ? newValue : null,
                      // functionInput: newValue?.id ? newValue?.id : "",
                      payload: {
                        ...state.payload,
                        // ...{
                        aggregationFormFormula: {
                          ...state.payload?.aggregationFormFormula,
                          // aggregationFormFormula: {
                          formInputFunction:
                            state.payload?.aggregationFormFormula
                              ?.formInputFunction,
                          grouping:
                            state.payload?.aggregationFormFormula?.grouping,
                          formInputId: null,
                          // },
                          // },
                        },
                      },
                    });
                  } else {
                    setState({
                      ...state,
                      payload: {
                        // ...{
                        ...state?.payload,
                        simpleFormFormula: {
                          ...state?.payload?.simpleFormFormula,
                          groupByFormInputId: null,
                          formInputIds:
                            state?.payload?.simpleFormFormula?.formInputIds,
                        },
                        // },
                      },
                      // state?.payload?.simpleFormFormula?.groupByFormInputId
                      // inputGroup: newValue?.id ? newValue?.id : "",
                    });
                  }
                }}
                // disabledfilter={!state.reportingUnitId}
                zIndexPopper={2}
                name={
                  stateTypeFilter === "AGGREGATION"
                    ? "formInputId"
                    : "groupByFormInputId"
                }
                id={
                  stateTypeFilter === "AGGREGATION"
                    ? "formInputId"
                    : "groupByFormInputId"
                }
                label={
                  stateTypeFilter === "AGGREGATION"
                    ? "Indikatori i funksionit"
                    : "Grupo sipas Indikatorit"
                }
                placeholder="Kërko Indikator"
                noOptionsText="Nuk ka Indikator"
                value={
                  stateTypeFilter === "AGGREGATION" &&
                  state?.payload?.aggregationFormFormula?.formInputId
                    ? state?.payload?.aggregationFormFormula?.formInputId
                    : state?.payload?.simpleFormFormula?.groupByFormInputId &&
                        state?.payload?.simpleFormFormula?.groupByFormInputId
                      ? state?.payload?.simpleFormFormula?.groupByFormInputId
                      : null
                }
                onClick={handleClickFunctionInput}
                source={formInputesById}
                maxWidth={"100%"}
                open={openFunctionInput}
                anchorEl={anchorElFunctionInput}
                onClickAway={handleCloseFunctionInput}
                onClose={(event, reason) => {
                  if (reason === "escape") {
                    handleCloseFunctionInput();
                  }
                }}
                onChange={(event, newValue, reason) => {
                  if (
                    event.type === "keydown" &&
                    event.key === "Backspace" &&
                    reason === "removeOption"
                  ) {
                    return;
                  }

                  if (stateTypeFilter === "AGGREGATION") {
                    setState({
                      ...state,
                      // functionInputObject: newValue ? newValue : null,
                      // functionInput: newValue?.id ? newValue?.id : "",
                      payload: {
                        ...state.payload,
                        // ...{
                        aggregationFormFormula: {
                          ...state.payload?.aggregationFormFormula,
                          // aggregationFormFormula: {
                          formInputFunction:
                            state.payload?.aggregationFormFormula
                              ?.formInputFunction,
                          grouping:
                            state.payload?.aggregationFormFormula?.grouping,
                          formInputId: newValue?.id ? newValue?.id : null,
                          // },
                          // },
                        },
                      },
                    });
                  } else {
                    setState({
                      ...state,
                      payload: {
                        // ...{
                        ...state?.payload,
                        simpleFormFormula: {
                          ...state?.payload?.simpleFormFormula,
                          groupByFormInputId: newValue?.id
                            ? newValue?.id
                            : null,
                          formInputIds:
                            state?.payload?.simpleFormFormula?.formInputIds,
                        },
                        // },
                      },
                      // state?.payload?.simpleFormFormula?.groupByFormInputId
                      // inputGroup: newValue?.id ? newValue?.id : "",
                    });
                  }

                  // setState({
                  //   ...state,
                  //   functionInput: newValue?.id ? newValue?.id : "",
                  // });
                  handleCloseFunctionInput();
                }}
                // onchangesearch={searchItemsForm}
                // inputRef={searchStateForm}
              ></SelectFilter>
            </Stack>
            {stateTypeFilter === "AGGREGATION" && (
              <Stack sx={{ margin: "0px 4px 16px" }}>
                <InputLabel required>Veprimi</InputLabel>
                <Select
                  value={
                    state?.payload?.aggregationFormFormula?.grouping
                      ?.groupingFunctionType ?? null
                  }
                  onChange={handleGroupingFunctionType}
                  sx={{
                    width: "230px",
                    height: "40px",
                    borderRadius: "5px",
                    backgroundColor: "#F6F8FC",
                    marginRight: "20px",
                  }}
                >
                  {[
                    { value: "COUNT", label: "COUNT" },
                    { value: "SUM", label: "SUM" },
                  ].map((item) => (
                    <MenuItem key={item.value} value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </Stack>
            )}
            {stateTypeFilter === "AGGREGATION" && (
              <Stack spacing={2} sx={{ mr: "10px", width: "100%" }}>
                <FormControlLabel
                  sx={{ marginRight: "40px", alignSelf: "flex-end" }}
                  value="start"
                  control={
                    <Checkbox
                      name="formInputFunctionBirthday"
                      id="formInputFunctionBirthday"
                      defaultChecked={false}
                      checked={formInputFunctionBirthday}
                      onChange={(e) => {
                        setFormInputFunctionBirthday(
                          !formInputFunctionBirthday,
                        );
                      }}
                    ></Checkbox>
                  }
                  label="Perllogaritje ditelindje"
                  labelPlacement="start"
                />
              </Stack>
            )}
            {stateTypeFilter === "AGGREGATION" && (
              <Stack spacing={2} sx={{ mr: "10px", width: "100%" }}>
                <FormControlLabel
                  sx={{ marginRight: "40px", alignSelf: "flex-end" }}
                  value="start"
                  control={
                    <Checkbox
                      name="formInputFunctionMonth"
                      id="formInputFunctionMonth"
                      defaultChecked={false}
                      checked={formInputFunctionMonth}
                      onChange={(e) => {
                        setFormInputFunctionMonth(!formInputFunctionMonth);
                      }}
                    ></Checkbox>
                  }
                  label="Perllogaritje sipas muajit"
                  labelPlacement="start"
                />
                {stateAggregationList && (
                  <Stack
                    sdirection="row"
                    spacing={1}
                    sx={{ margin: "0px 4px 16px" }}
                  >
                    <InputLabel>Indikatoret e Agregimit (Count)</InputLabel>
                    <MUITooltip
                      title={
                        stateListAggregationCountIndicator?.length !== 0 &&
                        stateListAggregationCountIndicator?.length !== undefined
                          ? stateListAggregationCountIndicator[0]?.label
                          : ""
                      }
                      arrow
                    >
                      <Autocomplete
                        multiple
                        // disabled={!state.formId}
                        onOpen={handleClickOshmaCategories}
                        // onClick={handleClickIndikator}
                        sx={{
                          "& .MuiAutocomplete-root .MuiOutlinedInput-root": {
                            padding: "0px !important",
                          },
                        }}
                        renderTags={(values) =>
                          stateListAggregationCountIndicator?.length !== 0
                            ? getCustomTextLength(
                                stateListAggregationCountIndicator[0]?.label,
                                20,
                              ) +
                              String(
                                stateListAggregationCountIndicator?.length > 1
                                  ? "  +"
                                  : "",
                              ) +
                              String(
                                stateListAggregationCountIndicator?.length > 1
                                  ? stateListAggregationCountIndicator?.length -
                                      1
                                  : "",
                              )
                            : ""
                        }
                        id="checkboxes-tags-demo"
                        options={formInputesById}
                        disableCloseOnSelect
                        value={stateListAggregationCountIndicator}
                        getOptionLabel={(option) => option.label}
                        renderOption={(props, option, { selected }) => (
                          <li {...props}>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option.label}
                          </li>
                        )}
                        onChange={(event, newValue, reason) => {
                          if (
                            event.type === "keydown" &&
                            event.key === "Backspace" &&
                            reason === "removeOption"
                          ) {
                            return;
                          }
                          setStateListAggregationCountIndicator(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            sx={{
                              minWidth: "250px",
                              // maxWidth: "250px",
                              height: "50px",

                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              // height: "auto",
                              marginRight: "20px",
                              // width: "min-content",

                              "& .Mui-disabled": {
                                "fieldset ": {
                                  // borderColor: "#72aeff !important",
                                  minWidth: "250px",
                                  // maxWidth: "250px",
                                },
                              },
                              "& .MuiInputBase-root.MuiOutlinedInput-root": {
                                backgroundColor: "#f6f8fc",
                                borderRadius: "12px",
                                height: "50px",
                              },
                              "& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled":
                                {
                                  WebkitTextFillColor: "#091B3D !important",
                                },
                            }}
                            {...params}
                          />
                        )}
                      />
                    </MUITooltip>
                  </Stack>
                )}
                {stateAggregationList && (
                  <Stack
                    sdirection="row"
                    spacing={1}
                    sx={{ margin: "0px 4px 16px" }}
                  >
                    <InputLabel>Indikatoret e Agregimit (SUM)</InputLabel>
                    <MUITooltip
                      title={
                        stateListAggregationIndicator
                          ? stateListAggregationIndicator[0]?.label
                          : ""
                      }
                      arrow
                    >
                      <Autocomplete
                        multiple
                        // disabled={!state.formId}
                        onOpen={handleClickOshmaCategories}
                        // onClick={handleClickIndikator}
                        sx={{
                          "& .MuiAutocomplete-root .MuiOutlinedInput-root": {
                            padding: "0px !important",
                          },
                        }}
                        renderTags={(values) =>
                          stateListAggregationIndicator.length !== 0
                            ? getCustomTextLength(
                                stateListAggregationIndicator[0]?.label,
                                20,
                              ) +
                              String(
                                stateListAggregationIndicator?.length > 1
                                  ? "  +"
                                  : "",
                              ) +
                              String(
                                stateListAggregationIndicator?.length > 1
                                  ? stateListAggregationIndicator?.length - 1
                                  : "",
                              )
                            : ""
                        }
                        id="checkboxes-tags-demo"
                        options={formInputesById}
                        disableCloseOnSelect
                        value={stateListAggregationIndicator}
                        getOptionLabel={(option) => option.label}
                        renderOption={(props, option, { selected }) => (
                          <li {...props}>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option.label}
                          </li>
                        )}
                        onChange={(event, newValue, reason) => {
                          if (
                            event.type === "keydown" &&
                            event.key === "Backspace" &&
                            reason === "removeOption"
                          ) {
                            return;
                          }

                          setStateListAggregationIndicator(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            sx={{
                              minWidth: "250px",
                              // maxWidth: "250px",
                              height: "50px",

                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              // height: "auto",
                              marginRight: "20px",
                              // width: "min-content",

                              "& .Mui-disabled": {
                                "fieldset ": {
                                  // borderColor: "#72aeff !important",
                                  minWidth: "250px",
                                  // maxWidth: "250px",
                                },
                              },
                              "& .MuiInputBase-root.MuiOutlinedInput-root": {
                                backgroundColor: "#f6f8fc",
                                borderRadius: "12px",
                                height: "50px",
                              },
                              "& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled":
                                {
                                  WebkitTextFillColor: "#091B3D !important",
                                },
                            }}
                            {...params}
                          />
                        )}
                      />
                    </MUITooltip>
                  </Stack>
                )}
                {stateAggregationList && (
                  <Stack
                    sdirection="row"
                    spacing={1}
                    sx={{ margin: "0px 4px 16px" }}
                  >
                    <InputLabel>
                      Indikatoret ne raport Indikatorit kryesor (%)
                    </InputLabel>
                    <MUITooltip
                      title={
                        stateListAggregationIndicatorPercentage
                          ? stateListAggregationIndicatorPercentage[0]?.label
                          : ""
                      }
                      arrow
                    >
                      <Autocomplete
                        multiple
                        // disabled={!state.formId}
                        onOpen={handleClickOshmaCategories}
                        // onClick={handleClickIndikator}
                        sx={{
                          "& .MuiAutocomplete-root .MuiOutlinedInput-root": {
                            padding: "0px !important",
                          },
                        }}
                        renderTags={(values) =>
                          stateListAggregationIndicatorPercentage.length !== 0
                            ? getCustomTextLength(
                                stateListAggregationIndicatorPercentage[0]
                                  ?.label,
                                20,
                              ) +
                              String(
                                stateListAggregationIndicatorPercentage?.length >
                                  1
                                  ? "  +"
                                  : "",
                              ) +
                              String(
                                stateListAggregationIndicatorPercentage?.length >
                                  1
                                  ? stateListAggregationIndicatorPercentage?.length -
                                      1
                                  : "",
                              )
                            : ""
                        }
                        id="checkboxes-tags-demo"
                        options={formInputesById}
                        disableCloseOnSelect
                        value={stateListAggregationIndicatorPercentage}
                        getOptionLabel={(option) => option.label}
                        renderOption={(props, option, { selected }) => (
                          <li {...props}>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option.label}
                          </li>
                        )}
                        onChange={(event, newValue, reason) => {
                          if (
                            event.type === "keydown" &&
                            event.key === "Backspace" &&
                            reason === "removeOption"
                          ) {
                            return;
                          }

                          setStateListAggregationIndicatorPercentage(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            sx={{
                              minWidth: "250px",
                              // maxWidth: "250px",
                              height: "50px",

                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              // height: "auto",
                              marginRight: "20px",
                              // width: "min-content",

                              "& .Mui-disabled": {
                                "fieldset ": {
                                  // borderColor: "#72aeff !important",
                                  minWidth: "250px",
                                  // maxWidth: "250px",
                                },
                              },
                              "& .MuiInputBase-root.MuiOutlinedInput-root": {
                                backgroundColor: "#f6f8fc",
                                borderRadius: "12px",
                                height: "50px",
                              },
                              "& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled":
                                {
                                  WebkitTextFillColor: "#091B3D !important",
                                },
                            }}
                            {...params}
                          />
                        )}
                      />
                    </MUITooltip>
                  </Stack>
                )}
              </Stack>
            )}

            {formInputFunctionMonth && (
              <Stack
                direction="column"
                spacing={1}
                sx={{ margin: "0px 4px 16px" }}
              >
                <InputLabel>Indikatori i perllogaritjes muaj</InputLabel>
                <SelectFilter
                  textfield
                  zIndexPopper={4}
                  name={"formInputMonth"}
                  id={"formInputMonth"}
                  label={"Indikatori i perllogaritjes muaj"}
                  placeholder="Kërko Indikator"
                  noOptionsText="Nuk ka Indikator"
                  value={formInputMonth}
                  onClick={handleClickFormInputMonth}
                  source={formInputesById}
                  maxWidth={"100%"}
                  open={openFormInputMonth} //bej ketu
                  anchorEl={anchorElFormInputMonth} //bej ketu
                  onClickAway={handleCloseFormInputMonth} //bej ketu
                  onClose={(event, reason) => {
                    if (reason === "escape") {
                      handleCloseFormInputMonth(); //bej ketu
                    }
                  }}
                  onChange={(event, newValue, reason) => {
                    if (
                      event.type === "keydown" &&
                      event.key === "Backspace" &&
                      reason === "removeOption"
                    ) {
                      return;
                    }
                    setFormInputMonth(newValue?.id);
                    handleCloseFormInputMonth();
                  }}
                ></SelectFilter>
              </Stack>
            )}

            {stateTypeFilter === "AGGREGATION" && (
              <>
                {" "}
                <Stack sx={{ margin: "0px 4px 16px" }}>
                  <InputLabel required>Tipi Filtrit</InputLabel>
                  <Select
                    value={aggregationFormFormulaGrouping}
                    onChange={handleAggregationFormFormulaGrouping}
                    sx={{
                      width: "230px",
                      height: "40px",
                      borderRadius: "5px",
                      backgroundColor: "#F6F8FC",
                      marginRight: "20px",
                    }}
                  >
                    {[
                      { value: "list", label: "List" },
                      { value: "number", label: "Fashe Numerike" },
                    ].map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Stack>
                <Stack
                  direction="column"
                  spacing={1}
                  sx={{ margin: "0px 4px" }}
                >
                  <InputLabel>Lista e Filtrit</InputLabel>
                  <RangeListManager
                    type={aggregationFormFormulaGrouping}
                    data={
                      state?.payload?.aggregationFormFormula?.grouping?.ranges
                        ? state?.payload?.aggregationFormFormula?.grouping
                            ?.ranges
                        : state?.payload?.aggregationFormFormula?.grouping
                              ?.labels
                          ? state?.payload?.aggregationFormFormula?.grouping
                              ?.labels
                          : null
                    }
                    onGetData={handleLabelChange}
                  />
                </Stack>
              </>
            )}
          </Stack>
        )}
        <Stack>
          <InputLabel>Apliko kod pas thirrjes (opsionale)</InputLabel>
          <textarea
            label="Apliko kod pas thirrjes (opsionale)"
            borderRadius={"16px"}
            name="postProcessing"
            id="postProcessing"
            value={state?.postProcessing}
            style={{
              width: "100%",
              minHeight: "200px",
              borderRadius: "15px",
              padding: "8px",
            }}
            heightTextField="200px"
            onChange={handleInputChange}
            multiline
          ></textarea>
        </Stack>
      </Stack>
      {data?.id && (
        <Stack>
          <InputLabel>Viti Testimit:</InputLabel>
          <Input
            type="number"
            value={yearTest}
            onChange={(e) => {
              setYearTest(Number(e.target.value));
            }}
          />
          <Button
            sx={{
              backgroundColor: "primary.dark",
              display: "flex",
              marginTop: "20px",
            }}
            startIcon={<PlayCircleFilledIcon />}
            onClick={generateDataQuery}
            variant="contained"
          >
            Testo
          </Button>
        </Stack>
      )}
      <ModalUI
        formname="Vlera qe kthen"
        open={openContentApiTest}
        sx={{ zIndex: "4000" }}
        onClose={() => setOpenContentApiTest(false)}
      >
        <Box>
          <pre
            style={{
              whiteSpace: "pre-wrap",
              background: "#eee",
              padding: "10px",
            }}
          >
            {stateContentApiTest}
          </pre>
        </Box>
      </ModalUI>
      <Stack sx={{ display: "flex", width: "100%" }}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "primary.dark",
            display: "flex",
            marginTop: "20px",
          }}
          startIcon={<Save />}
          onClick={saveDataQuery}
        >
          {isstatusnew ? "Shto" : "Ndrysho"}
        </Button>
      </Stack>
    </ModalUI>
  );
};
export default DataQueryModalEditor;
